/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type ChangeLicensingPasswordError = "INVALIDINPUT" | "MISSINGTOKEN" | "NEWPASSWORDINVALID" | "OLDPASSWORDINVALID" | "UNHANDLEDEXCEPTION" | "%future added value";
export type ChangeLicensingPasswordInput = {
    newPassword: string;
    oldPassword: string;
};
export type changePasswordMutationVariables = {
    input: ChangeLicensingPasswordInput;
};
export type changePasswordMutationResponse = {
    readonly changeLicensingPassword: {
        readonly errors: ReadonlyArray<{
            readonly errorCode: ChangeLicensingPasswordError;
            readonly message: string;
        } | null> | null;
        readonly wasSuccessful: boolean | null;
    } | null;
};
export type changePasswordMutation = {
    readonly response: changePasswordMutationResponse;
    readonly variables: changePasswordMutationVariables;
};



/*
mutation changePasswordMutation(
  $input: ChangeLicensingPasswordInput!
) {
  changeLicensingPassword(input: $input) {
    errors {
      errorCode
      message
    }
    wasSuccessful
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "ChangeLicensingPassword",
            "kind": "LinkedField",
            "name": "changeLicensingPassword",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "DetailedErrorOfChangeLicensingPassword",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "errorCode",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "message",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "wasSuccessful",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "changePasswordMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "changePasswordMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "1e9a891c8091aca83019cd412c7f9088",
            "id": null,
            "metadata": {},
            "name": "changePasswordMutation",
            "operationKind": "mutation",
            "text": "mutation changePasswordMutation(\n  $input: ChangeLicensingPasswordInput!\n) {\n  changeLicensingPassword(input: $input) {\n    errors {\n      errorCode\n      message\n    }\n    wasSuccessful\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = 'd748cbec5c62d3169156f9d6264be9f6';
export default node;
